"use client";




export default function Hero404() {
  return (
    <div className="mt-10 w-full">
      <div className="flex flex-col items-center">
        <div className="h-[60vh] flex flex-col items-center justify-center flex-grow w-full gap-8 px-4 py-20 lg:px-10">
          <h1 className="text-center text-5xl font-bold sm:text-7xl">
            Page not found
          </h1>
          <p className="text-lg text-center text-muted-foreground max-w-3xl">
            The page you’re looking for isn’t here. Maybe it was built elsewhere
            or taken down. Give us a call at 514-945-8852 if you need help
            finding what you need.
          </p>
          <a
            href="/"
            className="px-6 py-3 text-lg font-medium transition rounded-md shadow-md"
          >
            Return to Home
          </a>
        </div>
      </div>
    </div>
  );
}
